import { GraphModelShape } from '@ardoq/data-model';
import { GraphInterface } from '../graphInterface/graphInterface';

/**
 * Checks if a graph contains valid references and components.
 * @param graphInterface the GraphInterface allows to use scope data utils and BB models interchangeably.
 * @param param1 the GraphModelShape (typically this comes from graphModel$)
 * @returns true if every reference id, source component id, and target component id is a loaded reference or component.
 */
const isGraphModelValid = (
  graphInterface: GraphInterface,
  { referenceMap }: GraphModelShape
) =>
  Array.from(referenceMap.entries()).every(
    ([referenceId, { sourceId, targetId }]) =>
      graphInterface.isReference(referenceId) &&
      graphInterface.isComponent(sourceId) &&
      graphInterface.isComponent(targetId)
  );

export { isGraphModelValid };
